export default "__VITE_ASSET__DH03ONch__"